import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { BusinessRole } from 'src/constants/user';
import { ConsumerMyDataPage } from 'src/pages';
import { RouteProps } from 'src/types/router';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <ConsumerMyDataPage />,
    accessRoles: [BusinessRole.Employee],
  },
];

export const MY_DATA_ROUTE: RouteProps = {
  path: appRoutes.myData.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [ReactRouteAccessKey.anyAuthorized],
};
